import { DropzoneArea } from "material-ui-dropzone";
import styled from "styled-components";

export const StyledDropzone = styled(DropzoneArea)`
  .MuiDropzone-root {
    cursor: pointer;
  }
`;

export const Paragraph = styled.p`
    margin-bottom: 15px;
`;